import { Injectable } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { fromEvent } from 'rxjs';
import { Numbers } from 'src/app/utils/constants';
import { GtmTag } from '../../interfaces/data.interfaces';

@Injectable({
    providedIn: 'root'
})

export class GtmAutoService {
    dateStart: number;
    /**
     * @description constructor
     * @params gtmService
     * @params router
     */
    constructor(private gtmService: GoogleTagManagerService, private router: Router) {
        this.gtmService = gtmService;
        this.router = router;
    }
    /**
     * @description Metodo de inicio
     */
    init(): void {
        this.gtmService.addGtmToDom();
        this.registerRoutingEvents();
    }
    /**
     * @Description this method registers all pages with start and end.
     * @date 2020-07-13
     * @returns any returned
     */
    registerRoutingEvents(): void {
        this.router.events.forEach(item => {
            if (item instanceof NavigationStart) {
                this.dateStart = new Date().getTime();
            }
            if (item instanceof NavigationEnd) {
                const gtmTag: GtmTag = {
                    event: 'page',
                    timeLoading: (new Date().getTime() - this.dateStart) / Numbers.number1000,
                    pageName: item.url
                };
                this.gtmService.pushTag(gtmTag);
            }
        });
    }
    /**
     * @Description This method is used in order to register custom user events automatically.
     * It works by passing an array of valid JS events (provided in CUSTOM_EVENTS_TO_REGISTER)
     *  and calling to mapEvent Method
     * @date 2020-07-13
     * @param  arrayEvents:string[] an array of events
     * @returns  returns any
     */
    registerUserEvents(arrayEvents: string[]): void {
        for (const eventos of arrayEvents) {
            this.mapEvent(eventos);
        }

    }
    /**
     * @Description This method pushes the GTM object to the datalayer
     * @date 2020-07-13
     * @param  event the event to tag
     * @param  invokedMethod the method to invoke
     * @returns  returns any
     */
    registerCustomEvent(event: any, invokedMethod: any): void {
        const gtmTag: GtmTag = {
            event,
            data: invokedMethod
        };
        this.gtmService.pushTag(gtmTag);
    }
    /**
     * @Description this method is used in order to register standard events with GTM automatically
     * @date 2020-07-13
     * @param document this is the document
     * @param  event the event we want to bind
     * @returns  returns any
     */
    mapEvent(event: any): void {
        fromEvent(document, event).subscribe((res) => {
            // tslint:disable-next-line: deprecation
            const element: any = res.srcElement;
            if (element.dataset && element.dataset.gtmtag === event) {
                const gtmObject: {} = {};
                const keys: string [] = Object.keys(element.dataset);
                keys.forEach(key => {
                    const number3 = 3;
                    if (key.indexOf('gtm') === 0 && key !== 'gtmtag') {
                        gtmObject[key.substr(number3, key.length)] = element.dataset[key];
                    }
                });
                this.registerCustomEvent(event, gtmObject);
            }
        });
    }
}
